import React from 'react';
import { IntlProvider } from '@mb/lib/i18n/CoordinatedIntlProvider';
import { Banner } from './components/Banner';

const SustainabilityBanner = () => {
  return (
    <IntlProvider>
      <Banner />
    </IntlProvider>
  );
};

export default SustainabilityBanner;
